import { type Question } from 'shared-domains';

import Constants from '~/config/Constants';
import QuestionModel from '~/models/Question';
import Structure from '~/models/Structure';

export const QuestionTemplateStructure = {
  [Constants.SlideTypes.DROPDOWN]: {
    settings: {
      doesOptionHaveMultipleTargets: false,
      hasCorrectAnswer: true,
    },
    query: {
      type: null,
      hasMath: false,
      math: {
        latex: [],
        template: null,
      },
      answerTime: -1,
      text: '<p>Type question here including a <blank id="MRG80oTSH-9K"></blank> </p>',
      media: [],
    },
    options: [
      {
        type: 'text',
        hasMath: false,
        math: {
          latex: [],
          template: '',
        },
        answerTime: 0,
        id: '651657f8ae61808ccd3e5b9c',
        text: 'drop down',
        media: [],
        _id: '651657f8ae61808ccd3e5b9c',
      },
    ],
    kind: Constants.SlideTypes.DROPDOWN,
    marks: {
      correct: 1,
      incorrect: 0,
    },
    answer: [
      {
        targetId: 'MRG80oTSH-9K',
        optionId: ['651657f8ae61808ccd3e5b9c'],
      },
    ],
  },
  [Constants.SlideTypes.DRAGNDROP]: {
    settings: {
      doesOptionHaveMultipleTargets: false,
      hasCorrectAnswer: true,
    },
    query: {
      type: null,
      hasMath: false,
      math: {
        latex: [],
        template: null,
      },
      answerTime: -1,
      text: '<p>Type question here including an <blank id="2PSnurEPcWCz"></blank> </p>',
      media: [],
    },
    options: [
      {
        type: 'text',
        hasMath: false,
        math: {
          latex: [],
          template: '',
        },
        answerTime: 0,
        id: '651657f8ae61808ccd3e5b9c',
        text: 'answer option',
        media: [],
        _id: '651657f8ae61808ccd3e5b9c',
      },
    ],
    kind: Constants.SlideTypes.DRAGNDROP,
    marks: {
      correct: 1,
      incorrect: 0,
    },
    answer: [
      {
        targetId: '2PSnurEPcWCz',
        optionId: ['651657f8ae61808ccd3e5b9c'],
      },
    ],
  },
};

const QuestionFactoryTemplate = {
  createQuestionTemplate(type: string, qId: string): Question | undefined {
    const questionId = qId;

    switch (type) {
      case Constants.SlideTypes.DROPDOWN:
        return QuestionModel({
          _id: questionId,
          type: Constants.SlideTypes.DROPDOWN,
          time: Constants.QuestionDefaultTimes[Constants.SlideTypes.DROPDOWN],
          structure: Structure(QuestionTemplateStructure[Constants.SlideTypes.DROPDOWN]),
        });
      case Constants.SlideTypes.DRAGNDROP:
        return QuestionModel({
          _id: questionId,
          type: Constants.SlideTypes.DRAGNDROP,
          time: Constants.QuestionDefaultTimes[Constants.SlideTypes.DRAGNDROP],
          structure: Structure(QuestionTemplateStructure[Constants.SlideTypes.DRAGNDROP]),
        });
      default:
        return undefined;
    }
  },
};

export default QuestionFactoryTemplate;
